import React from "react";
import { Link } from "react-router-dom";
import "../style/home.css";

function About() {
  return (
    <div className="container home-page">
      <div className="row d-flex justify-content-center">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <p className="title-effect">Welcome to Anime_hunt website.</p>
          <hr />
          <p className="detail-words">
            The website will give you details about the anime searched as well
            as provide link for watching them
          </p>
          <p className="detail-words">Want to know about the API used.</p>
          <div style={{ textAlign: "center", marginTop: "5%" }}>
            <a className="link-style" href="https://jikan.docs.apiary.io/">
              {" "}
              <button
                type="button"
                className="btn btn-outline-success home-button"
              >
                Jikan API
              </button>
            </a>
            <Link to="/search">
              {" "}
              <button
                type="button"
                className="btn btn-outline-warning home-button"
              >
                Search Anime
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
